
  import { Component, Vue } from 'vue-property-decorator'
  import DictSelect from '@/components/busi/custom/dictselect.vue'
  import { 
    getSchoolGradeSubjectFeeList,
    getSchoolGradeSubjectFeeListCount,
    getAddSchoolFeeStandardList,
    getAddGradeSubjectFeeListCount,
    deleteAllSchoolGradeSubjectFee,
    deleteSchoolGradeSubjectFeeById,
    InsertSchoolGradeSubjectFee } from '@/api/enrollmentinformation'
  import { queryCriteriaGradeBySchoolId } from '@/api/common/common'
  import util from '@/utils/busi/util'

  
  @Component({
    name: 'standard',
    components: {
        DictSelect
    }
  })
  
  export default class Standard extends Vue {

    private addedStandardList = []
    private pagination = {
        currentPage:1,
        pageSize:10,
    }
    private totalCount = 0
    private schoolId = ''

    private addedStandardLoading = false
    private gradeData = []
    private headerCellStyle= { 'background-color': '#FAFAFA' }

    private schoolYearData=[
        {key:1,value:1},
        {key:2,value:2},
        {key:3,value:3},
        {key:4,value:4},
        {key:5,value:5},
        {key:6,value:6},
    ]
    created(){
        this.schoolId = util.getRouterParams().schoolId
        // 获取已配置列表
        this.getAddedStandardList()
        
        // 获取年级下拉列表
        queryCriteriaGradeBySchoolId({
            schoolId: this.schoolId
        }).then((res: any) => {
            if (res.code === 10000) {
                this.gradeData = res.object.list
            }
        })
    }

    // 获取已配置列表
    private getAddedStandardList() {
        // 获取已配置列表
        this.addedStandardLoading = true
        getSchoolGradeSubjectFeeList({
            schoolId:this.schoolId,
            pageSize:this.pagination.pageSize,
            currentPage:this.pagination.currentPage
        }).then((res: any) => {
            this.addedStandardList = res.object.list
            this.addedStandardLoading = false
        }).catch(err=>{
            this.addedStandardLoading = false
        })
        // 获取已配置列表总数
        getSchoolGradeSubjectFeeListCount({
            schoolId:this.schoolId
        }).then((res: any)=>{
            console.log(res)
            this.totalCount = Number(res.object.totalCount)
        })

    }


    private getAdvancePayment(items) {
        console.log(items)
        let amountTotal = 0
        for (let item of items) {
            amountTotal +=  Number(item.amount)
        }
        return amountTotal / 100
    }
    
    private dialogVisible = false

    private addStandard () {
        this.dialogVisible = true
    }

    private deteleAll () {
        this.$confirm('此操作将删除所有已添加的标准, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deleteAllSchoolGradeSubjectFee({
                schoolId:this.schoolId
            }).then(res=>{
                this.$message('刪除成功')
                // 获取已配置列表
                this.getAddedStandardList()
            }).catch(() => {
                this.$message('刪除失败')
            });
        }).catch(() => {
        });
    }

    private deleteStandardById(id){
        this.$confirm('确定删除此标准吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deleteSchoolGradeSubjectFeeById({
                id:id
            }).then(res=>{
                this.$message('刪除成功')
                // 获取已配置列表
                this.getAddedStandardList()
            }).catch(() => {
                this.$message('刪除失败')
            });
        }).catch(() => {
        });
        
    }

    private handleSizeChange () {
        // 获取已配置列表
        this.getAddedStandardList()
    }

    private handleCurrentChange () {
        // 获取已配置列表
        this.getAddedStandardList()
    }

    private dialogPagination = {
        currentPage:1,
        pageSize:10,
    }
    private dialogTotalCount = 0

    private form = {
        gradeId: '',
        subjectName: '',
        feeItemName: '',
        amount:'',
        schoolYear:''
    }


    private onReset () {
        this.form = {
            gradeId: '',
            subjectName: '',
            feeItemName: '',
            amount:'',
            schoolYear:''
        }
    }

    private unAddedStandardList = []
    private unAddedStandardLoading = false
    private emptyText = '请先选择’年级‘点击查询后查看数据！'

    // 获取可配置列表
    private getUnAddedStandardList(){
        // 获取可配置列表
        this.unAddedStandardLoading = true
        getAddSchoolFeeStandardList({
            schoolId:this.schoolId,
            currentPage:this.dialogPagination.currentPage,
            pageSize:this.dialogPagination.pageSize,
            ...this.form,
            amount: Number(this.form.amount) * 100
        }).then((res:any)=>{
            this.unAddedStandardList = res.object.list
            if(this.unAddedStandardList.length == 0){
                this.emptyText = '未找到收费标准，请修改查询条件后再点击查询!'
            }
            this.unAddedStandardLoading = false
        }).catch(err=>{
            this.unAddedStandardLoading = false
        })

        // 获取可配置列表数量
        getAddGradeSubjectFeeListCount({
            schoolId:this.schoolId,
            currentPage:this.dialogPagination.currentPage,
            pageSize:this.dialogPagination.pageSize,
            ...this.form,
            amount: Number(this.form.amount) * 100
        }).then((res:any)=>{
            this.dialogTotalCount = Number(res.object.totalCount)
        })
    }


    private onQuery(){
        this.dialogPagination.currentPage = 1
        this.getUnAddedStandardList()
    }
    private selectionStandardList = []
    private handleSelectionChange(selection){
        this.selectionStandardList = selection

    }
    private addLoading = false
    private onAdd(){
        if(this.selectionStandardList.length <= 0){
            this.$message('请选择标准')
            return
        } else {
            for (let item of this.selectionStandardList) {
                item.schoolId = this.schoolId
                item.amount = item.feeStandardMoney
                item.ifMust = item.feeMust
                item.state = item.feeStandardState
                item.feeItemId = item.itemId
            }
        }
        this.addLoading = true
        InsertSchoolGradeSubjectFee(this.selectionStandardList as any).then(res=>{
            this.addLoading = false
            // 添加成功
            this.$message('添加成功')
            // 刷新已配置列表
            this.getAddedStandardList()
            // 刷新可添加配置列表
            this.getUnAddedStandardList()
        }).catch(err=>{
            this.addLoading = false
        })
        
    }

    private open(){
        this.onReset()
        this.unAddedStandardList = []
    }

    private onClose(){
        this.dialogVisible = false
    }
    private handleDialogSizeChange () {
        console.log(this.dialogPagination)
        
        // 获取配置标准
        this.getUnAddedStandardList()
       
    }

    private handleDialogCurrentChange () {
        // 获取配置标准
        this.getUnAddedStandardList()
        
    }
    
  }
  